var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRedEnvelope(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 33,
    viewBox: "0 0 29 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1163 33H3.58805C1.61462 33 4.20475e-08 31.3814 0 29.403V4.22369C0 2.24532 1.61462 0.626648 3.58805 0.626648H25.1163C27.0898 0.626648 28.7044 2.24532 28.7044 4.22369V29.403C28.7044 31.3814 27.0898 33 25.1163 33Z",
    fill: "#F77C37"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3522 13.8486C20.3622 13.8486 25.6546 10.7911 28.7044 6.11497V3.59704C28.7044 1.61867 27.0898 0 25.1163 0H3.58805C1.61462 0 4.20475e-08 1.61867 0 3.59704V6.11497C3.04984 10.7911 8.34221 13.8486 14.3522 13.8486Z",
    fill: "#FF5C00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99194 12.77C8.99194 14.2009 9.5604 15.5733 10.5723 16.5852C11.5841 17.5971 12.9565 18.1655 14.3875 18.1655C15.8185 18.1655 17.1909 17.5971 18.2027 16.5852C19.2146 15.5733 19.7831 14.2009 19.7831 12.77C19.7831 11.339 19.2146 9.96658 18.2027 8.95471C17.1909 7.94285 15.8185 7.37439 14.3875 7.37439C12.9565 7.37439 11.5841 7.94285 10.5723 8.95471C9.5604 9.96658 8.99194 11.339 8.99194 12.77Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedEnvelope);
export default __webpack_public_path__ + "static/media/red-envelope.43975066.svg";
export { ForwardRef as ReactComponent };